import React from 'react'

// prettier-ignore
export const Equipment = {
  Dashboard: React.lazy(() => import('./dashboard')),
  Create:    React.lazy(() => import('./create')),
  Edit:      React.lazy(() => import('./edit')),
  List:      React.lazy(() => import('./list')),
}
